// Pan-tilt type options — used in individual device forms (DeviceDetailsForm, DeviceDynamicFields)
// Note: CH4-UCv2 is auto-assigned for SKU-onboarded devices and displayed as read-only
export const panTiltTypeOptions = [
  { value: "JSys", label: "JSys" },
  { value: "JSysV2", label: "JSysV2" },
];

export interface ISKUDeviceData {
  name: string; // matches catalog subcomponent name (e.g. "Optical 1", "Ch4")
  models: string[];
  hasRecordVideo?: boolean; // per-device recording setting from SKU config
  password?: string; // per-device password from SKU config (overrides customer default)
  defaultNodeName?: string; // catalog AGX name this device defaults to (e.g. "Agx 2")
}

export interface ISKUForm {
  skuNumber: string;
  configurationName: string;
  password?: string;
  hasRecordVideo?: boolean;
  defaultIp?: string;
  skuDataConfigurations: ISKUDeviceData[];
}

export const defaultSKUForm: ISKUForm = {
  skuNumber: "",
  configurationName: "",
  password: "",
  hasRecordVideo: true,
  defaultIp: "",
  skuDataConfigurations: [],
};

export const skuFormRules = {
  skuNumber: {
    required: true,
  },
  configurationName: {
    required: true,
  },
  skuDataConfigurations: {
    models: {
      required: false,
    },
    password: {
      minLength: 8,
    },
  },
};

export const modelLabelMap: Record<string, string> = {
  gasleak: "Leak",
  liquidleak: "Liquid Leak",
  firesmoke: "Fire/Smoke",
  hardhat: "Hard Hat",
  agg: "Gate Guard",
  tlm: "Tank Level",
};

// Static allowed models per subcomponent type — derived from SKU catalog component types.
// AGX and POE nodes have no model assignments (they are processing/power nodes).
export const ALLOWED_MODELS_BY_TYPE: Record<string, string[]> = {
  CH4: ["gasleak", "liquidleak"],
  VOC: ["gasleak", "liquidleak"],
  OPT: ["firesmoke", "hardhat", "liquidleak"],
  THM: ["liquidleak", "tlm"],
  LEGACY: ["gasleak", "liquidleak", "firesmoke", "hardhat", "agg", "tlm"],
};

// Friendly display labels for SKU component types.
// Used when DeviceMakes lookup fails for SKU-onboarded devices.
export const SKU_DEVICE_TYPE_LABELS: Record<string, string> = {
  AGX: "AGX",
  CH4: "CH4 Camera",
  OPT: "Optical Camera",
  THM: "Thermal Camera",
  VOC: "VOC Camera",
  LWOP: "LWOP Camera",
  POE: "POE Switch",
};

// Maps SKU makeModelId to component type
export const SKU_MAKE_MODEL_TO_TYPE: Record<string, string> = {
  CC_AGX: "AGX",
  CC_CH4: "CH4",
  CC_OPT: "OPT",
  CC_THERMAL: "THM",
  CC_VOC: "VOC",
  CC_LWOP: "LWOP",
  CC_POE: "POE",
};
